import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Prop, Emit } from 'vue-property-decorator';

var AppRadio = /*#__PURE__*/function (_Vue) {
  _inherits(AppRadio, _Vue);

  var _super = _createSuper(AppRadio);

  function AppRadio() {
    var _this;

    _classCallCheck(this, AppRadio);

    _this = _super.apply(this, arguments);
    _this.activeIndex = 0;
    return _this;
  }

  _createClass(AppRadio, [{
    key: "mounted",
    value: function mounted() {
      this.activeIndex = this.value;
    }
  }, {
    key: "switchValue",
    value: function switchValue(index) {
      this.activeIndex = index;
      return index;
    }
  }, {
    key: "slot",
    value: function slot(index) {
      return 'option_' + index;
    }
  }]);

  return AppRadio;
}(Vue);

__decorate([Prop()], AppRadio.prototype, "value", void 0);

__decorate([Prop()], AppRadio.prototype, "options", void 0);

__decorate([Prop({
  default: false
})], AppRadio.prototype, "disabled", void 0);

__decorate([Prop({
  type: String
})], AppRadio.prototype, "hint", void 0);

__decorate([Emit('input')], AppRadio.prototype, "switchValue", null);

AppRadio = __decorate([Component({})], AppRadio);
export default AppRadio;